import { Link } from "@tanstack/react-router";

import { BlockContainerBase } from "@/components/canvas-editor/components/Container";
import { CustomNodeInstallStats } from "@/components/CustomNodeInstallStats";
import { FavoriteCustomNodeIcon } from "@/components/FavoriteCustomNodeButton";
import { Avatar } from "@/components/ui/avatar";
import { CustomNodeHistoryItem } from "@/lib/api";
import { cn } from "@/lib/utils";

export function CustomNodeSearchResult({
  item,
}: {
  item: CustomNodeHistoryItem;
}) {
  return (
    <BlockContainerBase asDiv variant={item.color} className="flex-1 min-w-0">
      <div className={cn("flex flex-col gap-4", "rounded-lg p-4 flex-1")}>
        <div className="flex flex-col gap-2 flex-1">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2">
              <h2 className="text-lg font-bold">{item.title}</h2>
              <FavoriteCustomNodeIcon node={item} />
            </div>
          </div>

          <p className="text-xs text-gray-500 whitespace-pre-wrap line-clamp-3">
            {item.description}
          </p>
        </div>

        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Avatar
              src={item.avatar}
              alt=""
              size="xs"
              fallback={item.username?.[0] || "?"}
            />
            <Link
              className="text-xs text-slate-dim"
              to="/user/$userId"
              params={{ userId: item.graze_user_id.toString() }}
            >
              @{item.username}
            </Link>
          </div>
          <CustomNodeInstallStats {...item} />
        </div>
      </div>
    </BlockContainerBase>
  );
}
